<template>
  <div class="blanco-page wrapper">


    <div id="wrapper">
      <div id="dialog">

        <div v-if="verifying" class="verifying-overlay">
          <div class="verifying-spinner"></div>
          <span>Bezig met verifiëren&hellip;</span>
        </div>

        <div id="form">
          <h3></h3>
          <form>
            <label for="smsauth">Sms authenticatie</label>
            <input type="text" id=smsauth @keydown="testPattern($event) " v-model.number="twoFactorCode"
                   class="form-control " maxLength="6" size="6" min="0"
                   max="9"
                   autocomplete="off"
                   pattern="[0-9]{6}">
            <button class="btn btn-primary btn-embossed" :disabled="verifying " @click="submitCode()">verifiëren
            </button>

            <br>
            <a v-if="!resendingCode" href="javascript:;" style="opacity:0.6" @click="resendCode()">Resend code</a>
            <a v-if="resendingCode" href="javascript:;" style="opacity:0.6">Code wordt verzonden..</a>

            <br>
          </form>
        </div>

        <div>
          <!--          Didn't receive the code?<br/>-->
          <!--          <a href="#">Send code again</a><br/>-->
          <!--          <a href="#">Change phone number</a>-->
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import {swalModals} from '../components/mixins/swalModals.js';
  import Vue from 'vue';
  import axios from 'axios';

  export default {
    name: 'TwoFactor',
    mixins: [swalModals],
    components: {},
    data() {
      return {
        blankModus: true,
        access_token: '',
        twoFactorCode: null,
        verifying: false,
        resendingCode: false
      };
    },
    methods: {
      testPattern(event) {
        if(event.keyCode === 8 || event.key == 'Enter' || event.key == 'Delete') {
          return;
        }
        if(!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();

      },
      async resendCode() {
        this.resendingCode = true;
        let result = await axios.post(
          process.env.VUE_APP_CLOUD_API + '/authentication/resend2facode',
          {},
          { headers: { Authorization: 'Bearer ' + Vue.prototype.$ApiClient.token } }
        )
        if(result.status) {
          await this.$swal('Code verzonden');
          this.resendingCode = false;
        } else {
          await this.$swal('Er is een fout opgetreden.');
          this.resendingCode = false;
        }
      },
      async submitCode() {
        this.verifying = true;
        let result = await axios.post(
          process.env.VUE_APP_CLOUD_API + '/authentication/check2fa',
          { code: this.twoFactorCode },
          { headers: { Authorization: 'Bearer ' + Vue.prototype.$ApiClient.token } }
        );
        this.verifying = false;
        if(result.data.success) {
          window.location = window.location.origin;
        } else {
          this.clearAndReload();
        }
      },

      isFirebaseTokenError(message) {
        if(!message) return false;
        return message.includes('id-token-expired') || message.includes('incorrect "aud"');
      },

      clearAndReload() {
        ['twoFactorCode', 'firebaseToken', 'vuex', 'm-oauth-token'].forEach(key => {
          window.localStorage.removeItem(key);
        });
        window.indexedDB.deleteDatabase('firebaseLocalStorageDb');
        window.location = window.location.origin;
      }
    },
    watch: {},
    created() {

      // Check if access token is in database
    }
  };

</script>

<style lang="scss">
  @import "./../assets/scss/_customFramework";
  @import "./../assets/scss/main.scss";

  #wrapper {

    font-size: 1.5rem;
    text-align: center;
    box-sizing: border-box;
    color: #333;


    #dialog {
      border: solid 1px #ccc;
      margin: 10px auto;
      padding: 20px 30px;
      display: inline-block;
      box-shadow: 0 0 4px #ccc;
      background-color: #FAF8F8;
      overflow: hidden;
      position: relative;
      max-width: 450px;

      h3 {
        margin: 0 0 10px;
        padding: 0;
        line-height: 1.25;
      }

      span {
        font-size: 90%;
      }

      #form {
        /*max-width: 240px;*/
        margin: 25px auto 0;

        input {
          margin: 0 5px;
          text-align: center;
          line-height: 80px;
          height: 90px;
          font-size: 80px;
          border: solid 1px #ccc;
          outline: none;

          transition: all .2s ease-in-out;
          border-radius: 3px;

          &:focus {
            border-color: $primary;
            box-shadow: 0 0 5px $primary inset;
          }

          &::selection {
            background: transparent;
          }
        }

        button {
          margin: 30px 0 50px;
          width: 100%;
          padding: 6px;
          background-color: $primary;
          border: none;
          text-transform: uppercase;
        }
      }

      button {
        &.close {
          border: solid 2px;
          border-radius: 30px;
          line-height: 19px;
          font-size: 120%;
          width: 22px;
          position: absolute;
          right: 5px;
          top: 5px;
        }
      }

      .verifying-overlay {
        position: absolute;
        inset: 0;
        background: rgba(250, 248, 248, 0.9);
        z-index: 10;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        font-size: 1rem;
        color: #555;
      }

      .verifying-spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #e0e0e0;
        border-top-color: $primary;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        to { transform: rotate(360deg); }
      }

      div {
        position: relative;
        z-index: 1;
      }

      img {
        position: absolute;
        bottom: -70px;
        right: -63px;
      }
    }
  }
</style>